/**********************
 * WARNING!!!
 *
 * This component is called via the Credit Card  processor
 */

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { sendGET, sendPUT } from "../utils/comm";
import { progressSend } from "../utils/progress";
import CircularProgress from "@material-ui/core/CircularProgress";

/*
 Steps:`
    So the credit-card processor calls us and for paramters we get
    the user dateValue (id) and penniesPaid.
    We now want to tell the server about this success.
    The server will produce the PDF and email it to the user.
 */

export default (props) => {
  let { dateValue, pennies } = useParams();
  const [step, setStep] = useState("retrieve");
  const [surveyResult, setSurveyResult] = useState(null);
  useEffect(() => {
    // Send Google Analytics stuff...
    let revenue = Number(pennies) / 100;
    if (revenue === 0) revenue = 0.06; // Hack for SKIP mode so we can see SOME value go thru...
    let dataLayer = window.dataLayer;
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: "purchase",
      ecommerce: {
        purchase: {
          actionField: {
            id: dateValue,
            affiliation: "Complex Health Solutions",
            revenue,
            currency: "USD",
          },
          items: [
            {
              item_name: "Complex Survey", // Name or ID is required.
              item_id: "1",
              item_brand: "Complex Health Solutions",
              item_category: "Survey",
              price: revenue,
              quantity: "1",
            },
          ],
        },
      },
    });
    console.log("Success component; retrieve user data");
    sendGET(`/result/${dateValue}`)
      .then((surveyResult) => {
        console.log("Received from server:", surveyResult);
        surveyResult.paid = pennies !== 0;
        surveyResult.penniesPaid = pennies;
        surveyResult.pleaseSendReportNow = true; // IMPORTANT FLAG for the server to know!
        setStep("updating");
        console.log(
          "Sending update to server; pennies & pleaseSendReportNow..."
        );
        sendPUT("/result/" + surveyResult.dateValue, surveyResult).then(
          (data) => {
            console.log("Marked as paid:", data);
            setSurveyResult(surveyResult);

            progressSend({
              userEmail: surveyResult.userEmail,
              event: "*** COMPLETE AND PAID! *** " + pennies,
            }).then(() => {
              setStep("ack");
              console.log("ACK: Datalayer:", window.dataLayer);
            });
          }
        );
      })
      .catch((err) => {
        console.log("Failed result for  dateValue:", dateValue, "Err:", err);
        alert("Failed to  retrieve your report " + dateValue);
        //throw err;
      });
  }, [dateValue, pennies]);

  let style = {
    margin: "auto",
    width: "50%",
    backroundColor: "white",
    borderRadius: "30px",
    padding: "3em",
  };
  let outerStyle = {
    textAlign: "center",
    marginTop: "50px",
    fontSize: "1em",
    //fontWeight: "bold",
  };
  switch (step) {
    case "retrieve":
      return (
        <div style={outerStyle}>
          <div style={{ ...style, marginBottom: "1em" }}>
            Retrieving Invoice ID: <b>{dateValue}</b>...
          </div>
          <CircularProgress size={80} thickness={6} />
        </div>
      );
    case "updating":
      return (
        <div style={outerStyle}>
          <div style={{ ...style, marginBottom: "1em" }}>
            Updating Invoice ID: <b>{dateValue}</b> ...
          </div>
          <CircularProgress size={80} thickness={6} />
        </div>
      );
    case "ack":
      // means finished and payment recorded
      break;
    default:
      alert("Unkown step:" + step);
  }
  style = {
    backgroundImage: "none",
    background: "white",
    margin: "auto",
    width: "50%",
    borderRadius: "33px",
    fontSize: "1.2em",
    marginTop: "1em",
    padding: "3em",
  };
  const h1style = { fontSize: "1.5em" };
  return (
    <div style={style}>
      <h1 style={h1style}>Your transaction has been completed</h1>
      <p>
        For your records, your Invoice ID is <b>{surveyResult.dateValue}</b>;
        please save this ID for any communications with Complex Health
        Solutions.
      </p>
      <h2 style={h1style}>What's next...</h2>
      <p>
        Your report is being sent to {surveyResult.userEmail} coming from:{" "}
        <br />
        &nbsp;&nbsp;
        <a href="basic-report@complexhealthsolutions.com">
          basic-report@complexhealthsolutions.com
        </a>
        . <br />
        It should arrive within the next 5 minutes; please check your spam
        folder if you don't receive it.
      </p>
      <button
        onClick={(e) => {
          let location = window.location;
          // If in an iframe, we gotta break out to the parent
          if (window.parent !== window) location = window.parent.location;
          location.href = "https://www.complexhealthsolutions.com";
        }}
      >
        Return to home page
      </button>
    </div>
  );
};
